module.exports = __webpack_public_path__ + "static/img/v21-2.888f959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v21-2.png
// module id = 9mMP
// module chunks = 1